import React, { ComponentProps, ReactNode } from 'react'
import { TouchableOpacity, Text } from 'react-native'
import HGText from './HGText'

import styles from './styles'

type Props = ComponentProps<typeof Text> & {
  onPress: () => void
  children: ReactNode
}

const HGLink = (props: Props) => {
  const { children, style, ...textProps } = props

  return (
    <HGText {...textProps} style={[styles.link, style]}>
      {children}
    </HGText>
  )
}

export default HGLink
